export const ChallanTypeList = [
  { label: "Job Work", value: "Job Work" },
  { label: "Supply Of Liquid Gas", value: "Supply Of Liquid Gas" },
  { label: "Supply On Approval", value: "Supply On Approval" },
  { label: "Others", value: "Others" },
];
